module.exports = __webpack_public_path__ + "img/sgonzalez.9e1caf7d.jpg";